"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorConfig = void 0;
var view_1 = require("@codemirror/view");
var state_1 = require("@codemirror/state");
var language_1 = require("@codemirror/language");
var commands_1 = require("@codemirror/commands");
var autocomplete_1 = require("@codemirror/autocomplete");
var search_1 = require("@codemirror/search");
// Extensions for codemirror. Based on @codemirror/basic-setup, with javascript-specific
// extensions removed (lint, autocomplete). This is the base configuration for all codemirror
// editors on the site. Any changes here will impact Java Lab, Python Lab, and Web Lab 2.
var editorConfig = [
    (0, view_1.lineNumbers)(),
    (0, view_1.highlightSpecialChars)(),
    (0, commands_1.history)(),
    (0, language_1.foldGutter)(),
    (0, view_1.drawSelection)(),
    state_1.EditorState.allowMultipleSelections.of(true),
    (0, language_1.indentOnInput)(),
    (0, language_1.syntaxHighlighting)(language_1.defaultHighlightStyle, { fallback: true }),
    (0, language_1.bracketMatching)(),
    (0, autocomplete_1.closeBrackets)(),
    (0, view_1.rectangularSelection)(),
    (0, view_1.highlightActiveLine)(),
    (0, search_1.highlightSelectionMatches)(),
    view_1.keymap.of(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], autocomplete_1.closeBracketsKeymap, true), commands_1.defaultKeymap, true), search_1.searchKeymap, true), commands_1.historyKeymap, true), language_1.foldKeymap, true), [
        commands_1.indentWithTab,
    ], false)),
    state_1.EditorState.tabSize.of(2),
];
exports.editorConfig = editorConfig;
